import {Info} from "lucide-react";

import {Alert, AlertDescription, AlertTitle} from "@/components/ui/alert";
import {moment} from "@/src/modules/core/lib";
import {officerService} from "@/src/modules/officer/services";

export function NextShiftWarning() {
  const {nextShift} = officerService.getNextAndUpcomingShifts();
  if (!nextShift) return null;

  const fromDateTime = moment(nextShift.from_datetime);
  const isStartingToday = fromDateTime.isSame(moment(), "day");
  const isStartingTomorrow = fromDateTime.isSame(moment().add(1, "day"), "day");
  let content = "";

  if (isStartingToday) {
    content = `today at ${fromDateTime.format("HH:mm")}`;
  } else if (isStartingTomorrow) {
    content = `tomorrow at ${fromDateTime.format("HH:mm")}`;
  } else {
    content = `on ${fromDateTime.format("DD/MM/YYYY")} at ${fromDateTime.format("HH:mm")}`;
  }

  return (
    <Alert variant="warning">
      <Info />
      <AlertTitle>Next shift</AlertTitle>
      <AlertDescription>You have a shift starting {content}</AlertDescription>
    </Alert>
  );
}
